import {Component, inject, input, InputSignal, PLATFORM_ID} from '@angular/core';
import {IHairdresserResponse} from '../../interfaces/hairdresser.interface';
import {RouterLink} from '@angular/router';
import {NgClass, NgOptimizedImage, isPlatformBrowser} from '@angular/common';
import {AVATAR_PLACEHOLDER, IMAGE_PLACEHOLDER} from '../../constants/app.constants';
import {NgxPaginationModule} from 'ngx-pagination';
import {HairdressersService} from '../../services/hairdressers/hairdressers.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'braidsbook-hairdressers-list',
  imports: [
    RouterLink,
    NgOptimizedImage,
    NgxPaginationModule,
    NgClass,
    TranslatePipe
  ],
  templateUrl: './hairdressers-list.component.html'
})
export class HairdressersListComponent {
  readonly #hairdressersService: HairdressersService = inject(HairdressersService);
  readonly #platformId = inject(PLATFORM_ID);
  protected readonly IMAGE_PLACEHOLDER: string = IMAGE_PLACEHOLDER;
  protected readonly AVATAR_PLACEHOLDER: string = AVATAR_PLACEHOLDER;

  hairdresserResponse: InputSignal<IHairdresserResponse> = input.required();
  columns: InputSignal<number> = input<number>(3);

  getGridClasses(): string {
    const cols = this.columns();
    const gridClasses: Record<number, string> = {
      2: 'md:grid-cols-2',
      3: 'md:grid-cols-3',
      4: 'md:grid-cols-3 xl:grid-cols-4',
      5: 'md:grid-cols-3 xl:grid-cols-5',
      6: 'md:grid-cols-3 xl:grid-cols-6'
    };
    return gridClasses[cols] || gridClasses[3];
  }

  onPageChange(event: number): void {
    this.#hairdressersService.page.set(event);
    if (isPlatformBrowser(this.#platformId)) {
      window.scrollTo(0, 0);
    }
  }

}
